/**
 * accordion
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_accordion.css';
import './_accordion.twig';

export const name = 'accordion';

export const defaults = {
  dummyClass: 'js-accordion-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { accordion = {} }) {
  // Find our component within the DOM
  // eslint-disable-next-line no-undef
  const accordions = once('accordion-init', '.accordion', $context);
  // Bail if component does not exist
  if (!accordions.length) {
    return;
  }

  const $accordion = $(accordions);
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...accordion,
  };
  // An example of what could be done with this component
  $accordion.addClass(settings.dummyClass);

  $accordion.each(function accordionIterate() {
    // Hides the content.
    $('.accordion__item-content', this).hide();

    // Adds trigger click handler to open and close content.
    $('.accordion__item-trigger', this).click(function accordionTriggerHandler(
      e
    ) {
      e.preventDefault();

      $(this)
        .parent()
        .toggleClass('accordion__item--opened')
        .next()
        .slideToggle('down');
    });
  });
}

export default enable;
